<template>
    <div class="iconAnimation"
         :style="{backgroundPositionY:positionY + 'px',backgroundImage:'url('+bgUrl+')'}"
         @mouseenter="mouseenter"
         @mouseleave="mouseleave"></div>
</template>

<script>
    export default {
        name: "iconAnimation",
        data() {
            return {
                timer: null,
                positionY: 0
            }
        },
        props: ['bgUrl'],
        beforeDestroy() {
            if (this.timer) {
                clearInterval(this.timer)
            }
        },
        methods: {
            mouseenter() {
                if (this.timer) {
                    clearInterval(this.timer)
                }
                this.timer = setInterval(() => {
                    this.positionY -= 80
                    if (this.positionY <= -1520) {
                        this.positionY = -1520
                        clearInterval(this.timer)
                    }
                }, 30)
            },
            mouseleave() {
                if (this.timer) {
                    clearInterval(this.timer)
                }
                this.timer = setInterval(() => {
                    this.positionY += 80
                    if (this.positionY >= 0) {
                        this.positionY = 0
                        clearInterval(this.timer)
                    }
                }, 30)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .iconAnimation {
        margin: 0 auto 15px;
        width: 106px;
        height: 80px;
        background-position-x: 0;
        background-size: 100%;
        background-repeat: no-repeat;
        cursor: pointer;
        /*background-image: url("@/static/user/yibaoxian.png");*/
    }
</style>